export default "__VITE_ASSET__fdD79fUW__"